<template>
  <div class="v-container"><div class="center-wrapper"><article-preview /> <event-preview /></div></div>
</template>
<style scoped lang="scss">
.v-container {
  background-color: #f7f7f7;
}
.center-wrapper {
  display: flex;
  justify-content: space-around;
  max-width: 900px;
  margin: auto;
  height: 150px;
  & > * {
    max-height: 200px;
    margin: 1em;
    padding: 0.5em;
    background-color: white;
    flex-basis: 50%;
    &:first-child {
      text-align: right;
    }
  }
  @media screen and (max-width: 600px) {
    justify-content: inherit;
    flex-direction: column;
    height: 400px;
  }
}
</style>
<script>
import ArticlePreview from "./ArticlePreview";
import EventPreview from "./EventPreview";

export default {
  components: { EventPreview, ArticlePreview },
  name: "EventArticlePreview",

  props: { vuexApiData: Object }
};
</script>
